import type { AssessmentTestStore } from './interfaces'

export const getters = {
  hasData: (state: AssessmentTestStore): boolean => !state.loading && !!state.step && !!state.question,
  isLoading: (state: AssessmentTestStore): AssessmentTestStore['loading'] => state.loading,
  isHomeStep: (state: AssessmentTestStore): boolean => state.step === state.homeStep,
  isComprehension:  (state: AssessmentTestStore): AssessmentTestStore['comprehension'] => state.comprehension,
  isCompiling: (state: AssessmentTestStore): AssessmentTestStore['compiling'] => state.compiling,
  getAnswers: (state: AssessmentTestStore): AssessmentTestStore['answers'] => state.answers,
  getCurrentAnswer: (state: AssessmentTestStore): AssessmentTestStore['answer'] => state.answer,
  getCurrentStep: (state: AssessmentTestStore): AssessmentTestStore['step'] => state.step,
  getHomeStep: (state: AssessmentTestStore): AssessmentTestStore['homeStep'] => state.homeStep,
  getQuestions: (state: AssessmentTestStore): AssessmentTestStore['questions'] => state.questions,
  getCurrentQuestion: (state: AssessmentTestStore): AssessmentTestStore['question'] => state.question,
  getCurrentQuestionIndex: (state: AssessmentTestStore): number => state.questions.findIndex(question => question.name === state.question?.name),
  getQuestionsTotal: (state: AssessmentTestStore): AssessmentTestStore['questionsTotal'] => state.questionsTotal,
  getAssessmentTitle: (state: AssessmentTestStore): AssessmentTestStore['assessmentTitle'] => state.assessmentTitle,
  getAssessmentDescription: (state: AssessmentTestStore): AssessmentTestStore['assessmentDescription'] => state.assessmentDescription,
  getVariant: (state: AssessmentTestStore): string => state.variant.toLowerCase(),
  getTitle:  (state: AssessmentTestStore): AssessmentTestStore['title'] => state.title,
}
